import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { fetchCompany } from '../actions/company'

class CompanyLogo extends React.Component {

  render() {
    return (
      <img
        src={this.props.company ? this.props.company.logo_url : ""}
        className="img-fluid"
        alt={this.props.company ? this.props.company.name : ""} />
    )
  }
}

const mapStateToProps = state => ({
  company: state.company.company
})

const mapDispatchToProps = dispatch => bindActionCreators({ fetchCompany }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CompanyLogo)


// WEBPACK FOOTER //
// ./app/javascript/components/components/CompanyLogo.jsx